<div class="row">
    <div class="col-sm-12">
        Department of Agriculture, Laboratory Division
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        Department of Environmental Quality, Laboratory Division
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        Oregon Health Authority, Public Health Division
    </div>
</div>